const salesforceRoles = {
    CASENEST_RECEIVE_ADVICE: "Casenest Receive Advice",
};

export default salesforceRoles;